import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { ItemType, MenuPinType, iTag } from '../../../../shared/interfaces';

import EditIcon from '../../../../assets/svg/edit.svg';

import LocalPersonTile from '../../PersonTabPage/LocalPeopleTile';

import styles from './DeviceTags.module.scss';

type DeviceTagsProps = {
  deviceId: string;
  tags: Array<{ id: string; val: iTag }> | null | undefined;
  isPinned: boolean;
  isDriver: boolean;
  readOnly: boolean;
  title: string;
  cssOrder?: number;
  showPin?: boolean;
};

export const DeviceTags: React.FC<DeviceTagsProps> = ({ deviceId, tags, isPinned, isDriver, readOnly, title, cssOrder, showPin }) => {
  const [collapsed, setCollapsed] = useState<boolean>(isPinned);

  return (
    <LocalPersonTile
      collapsible
      initialCollapsed={collapsed}
      title={<span style={{ fontSize: 11 }}>{title}</span>}
      action={
        !isDriver &&
        !readOnly && (
          <Link to={`/${ItemType.device}/${deviceId}/add/tags`}>
            <img src={EditIcon} alt="editIcon" className={styles.editIcon} />
          </Link>
        )
      }
      isPinned={isPinned}
      withPin={showPin}
      property={MenuPinType.TAGS}
      order={cssOrder}
      leftIcon={null}
    >
      {!tags || tags.length === 0 ? (
        <div className={styles.empty}>None Yet</div>
      ) : (
        <div className={styles.tagsGrid}>
          {tags.map(({ val }) => (
            <Link
              to={`/${ItemType.tag}/${val.details.id}`}
              key={val.details.id}
              className={styles.tagItem}
              title={val.details.name}
            >
              {val.details.name}
            </Link>
          ))}
        </div>
      )}
    </LocalPersonTile>
  );
};
